import styled from 'styles/styled';

export const Title = styled.h3`
  font-size: 48px;
  font-weight: 500;
  color: #EFEFEF;
  text-align: center;
  text-shadow: 1px 3px 1px #000;
  margin-bottom: 20px;
  padding: 0 20px;
  @media (max-width: 1200px) {
    font-size: 38px;
  }
  @media (max-width: 720px) {
    font-size: 28px;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      font-size: 70px;
      font-weight: bold;
    }
  }
`;

export const SubTitle = styled.h3`
  font-size: 32px;
  font-weight: 500;
  color: #000;
  text-align: center;
  background-color: #52D381;
  padding: 15px 0;
  border-radius: 14px;
  margin-bottom: 20px;
  @media (max-width: 720px) {
    font-size: 18px;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      font-size: 50px;
      padding: 25px 0;
    }
  }
  &.inner {
    max-width: 300px;
    margin: 0 auto;
    margin-top: 10px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 1640px;
  margin: 0 auto;
  @media (max-width: 720px) {
    flex-direction: column;
    width: 100%;
    margin-bottom: 40px;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      max-width: 2000px;
    }
  }
`;

export const ContentPhoto = styled.div`
  width: calc(100% - 550px);
  justify-content: center;
  display: flex;
  @media (max-width: 1100px) {
    display: none;
  }
  @media (max-width: 720px) {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
  }
  img {
    width: 100%;
    max-width: 900px;
    max-height: calc(100vh - 280px);
    @media (max-width: 720px) {
      max-width: 400px;
      margin: 0 auto;
      width: 80%;
    }
    @media (min-width: 2300px) and (max-width: 2320px) {
      @media (min-height: 1330px) and (max-height: 1350px) {
        max-width: 950px;
        margin-right: 100px;
      }
    }
  }
`;

export const ContentResults = styled.div`
  width: 400px;
  background-color: #000;
  border-radius: 14px;
  position: relative;
  padding-bottom: 30px;
  @media (max-width: 720px) {
    width: 90%;
    max-width: 400px;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      width: 950px;
    }
  }
  &:after {
    background: linear-gradient(195.19deg, #000000 21.39%, #52D381 96.72%);
    position: absolute;
    content: " ";
    width: calc(100% + 2px);
    height: calc(100% + -1px);
    border-radius: 14px;
    top: 2px;
    left: -1px;
    z-index: -1;
  }
`;

export const LineText = styled.h4`
  text-align: center;
  font-size: 40px;
  background-color: #52D381;
  border-radius: 14px;
  color: #15191E;
  padding: 1px 0;
  font-weight: 900;
  min-width: 120px;
  padding: 20px 60px;
  display: table;
  margin: 20px auto 0 auto;
  @media (max-width: 720px) {
    font-size: 18px;
    margin: 20px auto 40px auto;
  }
`;

export const BoxContent = styled.div`
  margin-bottom: 15px;
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const TournamentRank = styled.ul`
  padding: 0 20px 0 10px;
  max-height: calc(100vh - 520px);
  min-height: 200px;
  overflow-y: scroll;
  margin-right: 12px;
  max-width: 320px;
  margin: 0 auto;
  @media (max-width: 720px) {
    width: 90%;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      max-width: 90%;
      margin-top: 40px;
      max-height: calc(100vh - 750px);
      padding: 0 35px 0 10px;
    }
  }
`;

export const TournamentList = styled.li`
  list-style-type: decimal;
  font-size: 11px;
  color: #EFEFEF;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: 4px;
  vertical-align: top;
  margin-left: 15px;
  @media (max-width: 720px) {
    vertical-align: top;
    line-height: 17px;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      font-size: 30px;
      line-height: initial;
      margin-bottom: 20px;
      font-weight: 400;
      margin-left: 65px;
    }
  }
  &:first-child {
    .ranking_125 {
      &:after {
        content: " (200 USDT in CET)";
        color: #FFD700;
      }
    }
    .Name_500 {
      &:after {
        content: " (300 USDT)";
        color: #FFD700;
      }
    }
    .Name_more,
    .Name {
      &:after {
        content: " (500 USDT)";
        color: #FFD700;
      }
    }
    .Name_87 {
      &:after {
        content: " (150 USDT)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(2) {
    .ranking_125 {
      &:after {
        content: " (150 USDT in CET)";
        color: #FFD700;
      }
    }
    .Name_500 {
      &:after {
        content: " (150 USDT)";
        color: #FFD700;
      }
    }
    .Name_more,
    .Name {
      &:after {
        content: " (300 USDT)";
        color: #FFD700;
      }
    }
    .Name_87 {
      &:after {
        content: " (100 USDT)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(3) {
    .ranking_125 {
      &:after {
        content: " (100 USDT in CET)";
        color: #FFD700;
      }
    }
    .Name_500 {
      &:after {
        content: " (50 USDT)";
        color: #FFD700;
      }
    }
    .Name_more,
    .Name {
      &:after {
        content: " (200 USDT)";
        color: #FFD700;
      }
    }
    .Name_87 {
      &:after {
        content: " (50 USDT)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(4) {
    .Name_87 {
      &:after {
        content: " (40 USDT)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(5) {
    .Name_87 {
      &:after {
        content: " (30 USDT)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(1n+4) {
    .ranking_125 {
      &:after {
        content: " (50 USDT in CET)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(1n+11) {
    .ranking_125 {
      &:after {
        content: " (20 USDT in CET)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(1n+21) {
    .ranking_125 {
      background-color: transparent;
      &:after {
        display: none;
      }
    }
  }

  &:nth-child(1n+6) {
    .Name_87 {
      &:after {
        content: " (25 USDT)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(1n+11) {
    .Name_87 {
      &:after {
        content: " (In-kind merchandising)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(1n+21) {
    .Name_87 {
      background-color: transparent;
      &:after {
        display: none;
      }
    }
  }

  &:nth-child(1n+4) {
    .Name_more {
      &:after {
        content: " (50 PLN)";
        color: #FFD700;
      }
    }
  }
  &:nth-child(1n+34) {
    .Name_more {
      background-color: transparent;
      &:after {
        display: none;
      }
    }
  }
`;

export const WrappList = styled.div`
  width: 100%;
  display: inline-block;
  vertical-align: top;
`;

export const TournamentBlet = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NickName = styled.h6`
  font-size: 11px;
  line-height: 18px;
  font-weight: 700;
  max-width: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  @media (max-width: 720px) {
    font-size: 11px;
    line-height: 15px;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      font-size: 30px;
      font-weight: 400;
      max-width: 260px;
      line-height: initial;
    }
  }
`;

export const Banner = styled.div`
  font-size: 20px;
  justify-content: center;
  align-items: center;
  display: none;
  margin-top: 20px;
  @media (max-width: 720px) {
    font-size: 14px;
    display: none;
  }
  &.ranking_BL {
    display: flex;
    @media (max-width: 720px) {
      display: none;
    }
  }
  img {
    max-width: 450px;
    margin-left: 5px;
    background-color: #000;
    padding: 15px;
    border-radius: 10px;

  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      font-size: 36px;
      margin-top: 40px;
      img {
        max-width: 700px;
      }
    }
  }
`;

export const Percent = styled.h6`
  font-size: 11px;
  line-height: 18px;
  font-weight: 700;
  @media (max-width: 720px) {
    font-size: 11px;
    line-height: 15px;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      font-size: 30px;
      line-height: inherit;
      font-weight: 400;
    }
  }
`;

export const Amount = styled.h6`
  font-size: 11px;
  color: #52D381;
  line-height: 20px;
  font-weight: 700;
  @media (max-width: 720px) {
    font-size: 9px;
    line-height: 15px;
  }
  &.up_state {
    color: #52D381;
  }
  &.down_state {
    color: #FF4B4A;
  }
  @media (min-width: 2300px) and (max-width: 2320px) {
    @media (min-height: 1330px) and (max-height: 1350px) {
      font-size: 28px;
      line-height: inherit;
      margin-top: 5px;
      font-weight: 400;
    }
  }
`;

export const Load = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: #EFEFEF;
`;

export const BeltBottom = styled.div`
  text-align: center;
  font-weight: 400;
  font-size: 30px;
  color: #EFEFEF;
  @media (max-width: 1100px) {
    margin-top: 40px;
  }
  @media (max-width: 720px) {
    margin-top: 0;
  }
  p {
    @media (max-width: 720px) {
      font-size: 18px;
    }
    @media (min-width: 2300px) and (max-width: 2320px) {
      @media (min-height: 1330px) and (max-height: 1350px) {
        font-size: 38px;
      }
    }
  }
`;

export const LoadWrap = styled.div`
  display: block;
  width: 32px;
  height: 32px;
  animation: rotation 800ms infinite linear;
  border-radius: 100%;
  box-shadow: 1px 1px 0 1px #52d382;
  margin-bottom: 20px;
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;
